import Solution from "../../components/admin/business_info/solution/Solution";

const AdminSolution = () => {
    return <Solution />;
};

export default AdminSolution;
